import {Component, OnInit} from '@angular/core';
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {MvsObjectNavigationService} from "../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectIdentifierData} from "../../../../../../core/shared/basic/object-identifier-data";
import {MvsObjectNavigationEntry} from "../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {ObjectIdentifier} from "../../../../../../core/shared/basic/object-identifier";


interface DunningTabConfig {
    header: string;
    icon: string;
    aliasSuffix: string;
    label: string;
    objectType: string;
    data?: WidgetData;
}

@Component({
    selector: 'bm-dunning-config',
    templateUrl: './dunning-config.component.html',
    standalone: false
})
export class DunningConfigComponent implements OnInit {

    initialized: boolean = false;
    config: DunningTabConfig;
    activeIndex = 0;
    tabConfigs: DunningTabConfig[] = [];

    constructor(
        protected navigationService: MvsObjectNavigationService
    ) {
    }

    ngOnInit(): void {
        this.initTabConfigs();
        this.loadWidgetData();
        this.initialized = true;
    }

    private initTabConfigs(): void {
        this.tabConfigs = [
            {
                header: 'Dunning Type',
                icon: 'fa-solid fa-regular fa-file-invoice',
                aliasSuffix: 'dunning-type',
                label: 'Dunning Type',
                objectType: 'bm.DunningType'
            },
            {
                header: 'Dunning Type Level',
                icon: 'fa-solid fa-regular fa-layer-group',
                aliasSuffix: 'dunning-type-level',
                label: 'Dunning Type Level',
                objectType: 'bm.DunningTypeLevel'
            },
            {
                header: 'Dunning Type Trigger',
                icon: 'fa-solid fa-regular fa-arrows-rotate',
                aliasSuffix: 'dunning-type-trigger',
                label: 'Dunning Type Trigger',
                objectType: 'bm.DunningTypeTrigger'
            },
            {
                header: 'Dunning Type Level Trigger',
                icon: 'fa-solid fa-regular fa-arrow-up-right-dots',
                aliasSuffix: 'dunning-type-level-trigger',
                label: 'Dunning Type Level Trigger',
                objectType: 'bm.DunningTypeLevelTrigger'
            },
            {
                header: 'Dunning Type Trigger Logic Field',
                icon: 'fa-solid fa-regular fa-tools',
                aliasSuffix: 'dunning-type-trigger-logic-field',
                label: 'Dunning Type Trigger Logic Field',
                objectType: 'bm.DunningTypeTriggerLogicField'
            },
            {
                header: 'Dunning Type Level Trigger Logic Field',
                icon: 'fa-solid fa-regular fa-database',
                aliasSuffix: 'dunning-type-level-trigger-logic-field',
                label: 'Dunning Type Level Trigger Logic Field',
                objectType: 'bm.DunningTypeLevelTriggerLogicField'
            },
            {
                header: 'Dunning Status Type',
                icon: 'fa-solid fa-regular fa-circle-dot',
                aliasSuffix: 'dunning-status-type',
                label: 'Dunning Status Type',
                objectType: 'bm.DunningStatusType'
            }
        ];
    }

    private loadWidgetData(): void {
        for (const tab of this.tabConfigs) {
            tab.data = this.createWidgetData(tab.aliasSuffix, tab.label, tab.objectType);
        }
    }

    private createWidgetData(aliasSuffix: string, label: string, objectType: string): WidgetData {
        return WidgetFactory.createWidgetTableEntity(
            `bm.page.overview.dunning.config.${aliasSuffix}`,
            label,
            objectType,
            'Keine Einträge gefunden.',
            ObjectRequestList.createBasic(true, [], [])
        );
    }

    handleObjectSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        if(event.objectType == 'bm.DunningType'){
            const entry = MvsObjectNavigationEntry.createNavigationEntry(event.objectType, event.objectId, null, null, null, null, MvsObjectNavigationActionEnum.any)
            this.navigationService.openObjectInNewTab(entry);
        }
    }
}
